import { AcpStatusBadge } from "@/components/ACP/AcpStatusBadge";
import type { ACPStatus } from "@/lib/types/acp";
import { Tooltip2 } from "@/ui2/molecules/Tooltip";

export function MemberProfileAcpBadge({ status }: { status: ACPStatus }) {
  return (
    <Tooltip2 text={getTooltipText(status)}>
      <AcpStatusBadge status={status} />
    </Tooltip2>
  );
}

function getTooltipText(status: ACPStatus): string {
  switch (status) {
    case "OPTED_OUT":
      return "Patient has explicitly opted out of the Advanced Care Program. Do not contact regarding ACP enrollment.";

    case "OPTED_IN":
      return "Patient has consented to participate in the Advanced Care Program.";

    case "NOT_RESPONDED":
      return "Patient has not accepted Advanced Care Program consent yet.";

    case "NOT_ELIGIBLE":
      return "Patient's insurance plan does not cover Advanced Care Program.";
  }
}
